import { forwardRef, DetailedHTMLProps, InputHTMLAttributes } from 'react';
import cn from 'classnames';
// Styles
import styles from './CheckBox.module.scss';

type Props = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  label?: string;
  labelClassName?: string;
  boldLabel?: boolean;
  alignLabelTop?: boolean;
  id?: string;
  error?: string;
};

const CheckBox = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      label,
      labelClassName,
      boldLabel,
      className,
      alignLabelTop,
      id = name,
      error,
      ...rest
    },
    ref
  ) => {
    return (
      <div className={cn(styles.checkBoxContainer, className)}>
        <input
          className={cn(styles.checkBoxInput, { [styles.error]: !!error })}
          ref={ref}
          name={name}
          id={id}
          type="checkbox"
          {...rest}
        />

        <label
          htmlFor={id}
          className={cn(
            styles.checkBoxLabel,
            {
              [styles.bold]: boldLabel,
              [styles.alignTop]: alignLabelTop,
              [styles.error]: !!error,
            },
            labelClassName
          )}
        >
          {label}
        </label>
      </div>
    );
  }
);

CheckBox.displayName = 'CheckBox';

export default CheckBox;
